/* eslint-disable react-hooks/exhaustive-deps */
import { Checkbox, Divider, Form, Input, Modal, Select } from 'antd';
import Steps from 'rc-steps';
import { useState, useEffect } from 'react';

import StepWizard from 'react-step-wizard';
import { StepsButton } from './BtnSave';
import MeasuresOrganize from './MeasuresOrganize';
import DPIAService from '../../../services/DPIA.service';
import IconEmpty from './iconEmpty';
import { useTranslation } from 'react-i18next';
import init from './init.json';
import { STATUS_ID } from './Step5';

import { useDpiaContext } from '../dpia.context';
import { t } from 'i18next';

export default function Step6(props) {
    const { t } = useTranslation(['translation', 'dpia']);
    const { setMeasures, setStepNo } = useDpiaContext();

    const [current, setCurrent] = useState(0);
    const [state, updateState] = useState();
    const [open, setOpen] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);

    const getDPIAMeasures = async () => {
        setLoading(true);
        try {
            const { data } = await DPIAService.getDPIAMeasures();
            if (data?.resultData) {
                setDataSource(data?.resultData);
                setMeasures(data?.resultData);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        getDPIAMeasures();
    }, []);

    const onChange = (value) => {
        setCurrent(value);
        state?.SW?.goToStep(value + 1);
    };

    const setInstance = (SW) => {
        updateState({
            ...state,
            SW,
        });
    };
    useEffect(() => {
        setStepNo(6)
    }, []); 
    return (
        <div hidden={!props?.isActive}>
            <div className="w-full flex justify-end">
                <Steps
                    className="bg-[#F5F6FF] rounded-md inline-step"
                    type="inline"
                    current={current}
                    onChange={onChange}
                    items={[
                        {
                            status: current === 0 ? 'process' : 'wait',
                            title: '6.1',
                        },
                        {
                            status: current === 1 ? 'process' : 'wait',
                            title: '6.2',
                        },
                    ]}
                />
            </div>
            <div className="text-2xl font-semibold text-purple-PHX">
                {t('Step', { ns: 'dpia' })} 6 : Mitigating measures
            </div>
            <div className="text-[#65707A]">
                {t('When the data controller', { ns: 'dpia' })}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                initialValues={init.measures}
                layout="vertical"
                name="measures"
                form={props?.form}
            >
                <StepWizard
                    onStepChange={({ activeStep }) => {
                        setCurrent(activeStep - 1);
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                    instance={setInstance}
                >
                    <Step61
                        dataSource={dataSource}
                        setOpen={setOpen}
                        back={() => props?.previousStep()}
                        form={props?.form}
                    />
                    <Step62
                        dataSource={dataSource}
                        setOpen={setOpen}
                        form={props?.form}
                        next={() => props?.nextStep()}
                    />
                </StepWizard>
            </Form>
            <Modal
                className="_modal"
                centered
                open={open}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                width={1200}
                footer={false}
            >
                <MeasuresOrganize
                    dataSource={dataSource}
                    loading={loading}
                    getDPIAMeasures={getDPIAMeasures}
                />
            </Modal>
        </div>
    );
}

function Step61({ dataSource = [], ...props }) {
    const dpiaMitigating = Form.useWatch('dpiaMitigating', props.form);
    const step6_2 = Form.useWatch('dpiaMitigatingMeasuresList', props.form);

    useEffect(() => {
        const dpiaMitigatingMeasuresList = dpiaMitigating?.map((id, i) => {
            const dpiaMitigating = dataSource.find(
                (d) => d?.dpiaMitigatingMeasuresOrganizeId === id
            );
            const oldData = step6_2?.find(
                (step) => step?.dpiaMitigatingMeasuresOrganizeId === id
            );
            return {
                dpiaMitigatingMeasuresOrganizeId: id,
                dpiaMitigatingMeasuresOrganizeName:
                    dpiaMitigating?.dpiaMitigatingMeasuresOrganizeName,
                effectOnRisk: oldData?.effectOnRisk || null,
                remainingRisk: oldData?.remainingRisk || null,
                considerationResult: oldData?.considerationResult || null,
                considerationBy: oldData?.considerationBy || null,
                sequence: i + 1,
            };
        });
        props?.form?.setFieldValue(
            'dpiaMitigatingMeasuresList',
            dpiaMitigatingMeasuresList
        );
    }, [dataSource, dpiaMitigating, props?.form, step6_2]);

    const onNextStep = () => {
        props.nextStep();
    };
    return (
        <div hidden={!props?.isActive}>
            <div className="text-xl font-bold flex justify-between items-center">
                <div>
                    {' '}
                    6.1) {t('Measures used to reduce risks', { ns: 'dpia' })}
                </div>
                <a
                    onClick={() => props.setOpen(true)}
                    className="text-base text-[#1890FF] underline"
                >
                    {t('Add other measures', { ns: 'dpia' })}
                </a>
            </div>
            <div>
                {t(
                    'Please select the measures used to reduce the risk. Select more than one option',
                    { ns: 'dpia' }
                )}
            </div>
            <Form.Item name="dpiaMitigating">
                <Checkbox.Group className="space-y-2 my-4">
                    {dataSource?.map((impact) => (
                        <>
                            <Checkbox
                                key={impact.dpiaMitigatingMeasuresOrganizeId}
                                value={impact.dpiaMitigatingMeasuresOrganizeId}
                            >
                                {impact.dpiaMitigatingMeasuresOrganizeName}
                            </Checkbox>
                            <br />
                        </>
                    ))}
                </Checkbox.Group>
            </Form.Item>
            <Divider />
            <StepsButton previous={props?.back} next={onNextStep} />
        </div>
    );
}

function Step62({ dataSource, ...props }) {
    const { t } = useTranslation(['translation', 'dpia']);
    const onPreviousStep = () => {
        props.previousStep();
    };
    const dpiaMitigatingMeasuresList = Form.useWatch(
        'dpiaMitigatingMeasuresList',
        props.form
    );

    return (
        <div hidden={!props?.isActive}>
            <div className="text-xl font-bold">
                <div>
                    6.2){' '}
                    {t('Evaluate the measures used to reduce risks', {
                        ns: 'dpia',
                    })}
                </div>
            </div>
            <div>
                {t('Based on the identified risks and measures', {
                    ns: 'dpia',
                })}
            </div>
            <Form.List name="dpiaMitigatingMeasuresList">
                {(fields) => (
                    <>
                        {fields.map(({ key, name, ...restField }) => {
                            return (
                                <div key={name} className="my-4">
                                    <div className="font-semibold text-base">
                                        {t('Measure', { ns: 'dpia' })}{' '}
                                        {name + 1} :{' '}
                                        {dpiaMitigatingMeasuresList?.length >
                                            0 &&
                                            dpiaMitigatingMeasuresList[name]
                                                ?.dpiaMitigatingMeasuresOrganizeName}
                                    </div>

                                    <div className="grid grid-cols-3 gap-4 mt-4">
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'effectOnRisk']}
                                            label={t('Impact on Risk', {
                                                ns: 'dpia',
                                            })}
                                            className="w-full mb-0 col-span-1"
                                        >
                                            <Select
                                                size="large"
                                                placeholder={t(
                                                    'Select Impact on Risk',
                                                    { ns: 'dpia' }
                                                )}
                                                style={{ width: '100%' }}
                                                options={[
                                                    {
                                                        value: STATUS_ID.AWAY,
                                                        label: t('Away', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                    {
                                                        value: STATUS_ID.REDUCE,
                                                        label: t('Reduce', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                    {
                                                        value: STATUS_ID.ACCEPTABLE,
                                                        label: t('Acceptable', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                ]}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'remainingRisk']}
                                            label={t('Remaining Risk', {
                                                ns: 'dpia',
                                            })}
                                            className="w-full mb-0 col-span-1"
                                        >
                                            <Select
                                                size="large"
                                                placeholder={t(
                                                    'Select Remaining Risk',
                                                    { ns: 'dpia' }
                                                )}
                                                style={{ width: '100%' }}
                                                options={[
                                                    {
                                                        value: STATUS_ID.LOW,
                                                        label: t('Low', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                    {
                                                        value: STATUS_ID.MEDIUM,
                                                        label: t('Center', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                    {
                                                        value: STATUS_ID.HIGH,
                                                        label: t('High', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                ]}
                                            />
                                        </Form.Item>
                                        <div className="col-span-1" />
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'considerationResult']}
                                            label={t('Assessment Result', {
                                                ns: 'dpia',
                                            })}
                                            className="w-full mb-0 col-span-1"
                                        >
                                            <Select
                                                size="large"
                                                placeholder={t(
                                                    'Select Assessment Result',
                                                    { ns: 'dpia' }
                                                )}
                                                style={{ width: '100%' }}
                                                options={[
                                                    {
                                                        value: STATUS_ID.APPROVE,
                                                        label: t('Approved', {
                                                            ns: 'dpia',
                                                        }),
                                                    },
                                                    {
                                                        value: STATUS_ID.NOT_APPROVE,
                                                        label: t(
                                                            'Not Approved',
                                                            { ns: 'dpia' }
                                                        ),
                                                    },
                                                ]}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'considerationBy']}
                                            label={t('Consideration By', {
                                                ns: 'dpia',
                                            })}
                                            className="w-full mb-0 col-span-2"
                                        >
                                            <Input
                                                size="large"
                                                placeholder={t(
                                                    'Consideration By',
                                                    { ns: 'dpia' }
                                                )}
                                                showCount
                                                maxLength={150}
                                            />
                                        </Form.Item>
                                    </div>
                                    <Divider className="mt-3 mb-3" />
                                </div>
                            );
                        })}
                    </>
                )}
            </Form.List>
            {(!dpiaMitigatingMeasuresList ||
                dpiaMitigatingMeasuresList?.length === 0) && (
                <div className="text-center m-auto my-44">
                    <IconEmpty />
                    <div>
                        {t('No information found')}
                        <br />
                        {t('Please enter information in step', {
                            step: ' 6.1',
                        })}
                    </div>
                </div>
            )}
            <Divider />
            <StepsButton previous={onPreviousStep} next={props?.next} />
        </div>
    );
}
